import React from "react";
import PropTypes from "prop-types";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import faBarcodeAlt from "@fortawesome/fontawesome-pro-light/faBarcodeAlt";

const PurchaseOrderItem = ({ purchaseOrder, deleteCard, isDeleting }) => {
  const poDescription = purchaseOrder.props
    ? purchaseOrder.props.description
    : null;

const deleteButton = (deleteCard)
  ? <span>
      <button
        type="button"
        className="btn btn-danger btn-sm ml-2"
        onClick={() => {
          deleteCard(purchaseOrder.id);
        }}
        disabled={isDeleting}
      >
        {isDeleting && (
          <i className="fa fa-cog fa-spinner fa-spin fa-spin mr-1" />
        )}
        Delete
      </button>
    </span>
  : null;

  return (
    <li className="list-group-item list-group-item-action d-flex justify-content-between">
      <div>
        <FontAwesomeIcon style={{ marginRight: 5 }} icon={faBarcodeAlt} />
        {/* <i
          className="fa fa-credit-card"
          aria-hidden="true"
          style={{ marginRight: 5 }}
        /> */}
        {poDescription.split("\n").map((item, idx) => (
          <span style={{ fontFamily: "Arial", fontSize: 12 }} key={idx}>
            {item}
            <br />
          </span>
        ))}
        {/* <span style={{ fontFamily: 'Arial', fontSize: 12 }}>{poDescription}</span> */}
      </div>
      {deleteButton}
    </li>
  );
};

PurchaseOrderItem.propTypes = {
  purchaseOrder: PropTypes.object.isRequired,
  deleteCard: PropTypes.func,
};

export default PurchaseOrderItem;



// WEBPACK FOOTER //
// ./src/views/Admin/PurchaseOrderItem.js